var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6791_62411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.7 10.0066L8.8225 7.88406L4.18 3.24905C3.82 2.88905 3.1975 2.98655 2.9725 3.45155C2.44 4.56905 2.635 5.94155 3.5575 6.87155L6.7 10.0066ZM11.785 8.64905C12.9325 9.18155 14.545 8.80655 15.7375 7.61405C17.17 6.18155 17.4475 4.12656 16.345 3.02406C15.25 1.92905 13.195 2.19906 11.755 3.63156C10.5625 4.82405 10.1875 6.43655 10.72 7.58405L3.925 14.3791C3.6325 14.6716 3.6325 15.1441 3.925 15.4366C4.2175 15.7291 4.69 15.7291 4.9825 15.4366L9.625 10.8091L14.26 15.4441C14.5525 15.7366 15.025 15.7366 15.3175 15.4441C15.61 15.1516 15.61 14.6791 15.3175 14.3866L10.6825 9.75155L11.785 8.64905Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6791_62411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.a63c373f870593e4444a87808fb7ac29.svg";
export { ForwardRef as ReactComponent };